import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_BA: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitnes',
  components_header_media_1: 'Za muškarce',
  components_header_media_2: 'Za žene',
  components_header_media_multi_content_2: 'Joga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trenirajte pametnije, osjećajte se bolje.',
  hero_button_text: 'Započnite odmah',
  components_ressources_subheader_text: 'Vodiči i savjeti',
  components_ressources_span_text: 'Kombinuje zemaljski fokus joge, kontrolisanu preciznost Pilatesa i dinamičan izazov treninga snage kako bi podržao sveobuhvatan i zdrav način života.',
  components_ressources_card_1_title: 'Savjeti za jogu',
  components_ressources_card_1_text: 'Kratki vodič za bolju ravnotežu, disanje i protok.',
  components_ressources_card_2_title: 'Savjeti za pilates',
  components_ressources_card_2_text: 'Jednostavni savjeti za jačanje mišića trupa i poboljšanje kontrole.',
  components_notes_and_google_title_1: 'Izgradite snagu',
  components_notes_and_google_title_2: 'Joga smirenost',
  components_notes_and_google_title_3: 'Pilates jezgro',
  media_content_section_multi_1_subheader_text: 'Videozapisi za obuku',
  media_content_section_multi_2_subheader_text: 'Joga videozapisi',
  media_content_section_multi_3_subheader_text: 'Pilates videozapisi',
  text_media_1: 'Muškarci',
  text_media_2: 'Žene',
  page_media_content_menu_biceps: 'Bicepsi',
  page_media_content_menu_triceps: 'Tricepsi',
  page_media_content_menu_back: 'Nazad',
  page_media_content_menu_chest: 'Prsa',
  page_media_content_menu_legs: 'Noge',
  page_media_content_menu_shoulders: 'Ramena',
  page_media_content_menu_abdominals: 'Trbušni mišići',
  components_text1_subheader_text: 'Zdrava prehrana za vaš aktivan život',
  components_text1_span_text: 'Zdravi recepti koji podržavaju vaš trening i poboljšavaju vaše blagostanje.',
  components_footer_text: 'Ojačajte svoje tijelo, uravnotežite svoj um i krećite se sa smislom – vaše mjesto za teretanu, jogu i pilates.',
};